<template>
    <div>
        <div class="wrap" v-if="userInfo.isMerchant==1 || dataObj.approvalStatus|| dataObj.approvalStatus==0 ">
        <el-button size="mini" class="topBtn" type="primary" plain v-if="dataObj.approvalStatus == 1" @click="edit">编辑</el-button>
        <el-button size="mini" class="topBtn" type="primary" plain v-if="dataObj.approvalStatus == 2" @click="edit">再次申请</el-button>
       <div class="topBox">
           <div class="topBox-p">
                <div class="p1">经办人姓名：</div>
                <div class="p2">{{dataObj.name}}</div>
                <div class="p3" v-if="dataObj.approvalStatus == 0">
                    <img class="img1" src="../../assets/img/daishenhe2.png" alt="">
                </div>
                <div class="p4" v-if="dataObj.approvalStatus == 1">
                    <img class="img1" src="../../assets/img/daishenhe.png" alt="">
                </div>
                <div class="p5" v-if="dataObj.approvalStatus == 2">
                    <img class="img1"  src="../../assets/img/weitongguo.png" alt="">
                </div>
            </div>
            <div class="topBox-p">
                <div class="p1">手机号码：</div>
                <div class="p2">{{dataObj.phone}}</div>
            </div>
            <div class="topBox-p">
                <div class="p1">经营场所名称：</div>
                <div class="p2">{{dataObj.businessName}}</div>
            </div>
            <div class="topBox-p">
                <div class="p1">经营地址：</div>
                <div class="p2">{{dataObj.region+','+dataObj.address}}</div>
            </div>
            <div class="topBox-p">
                <div class="p1">批发商类型：</div>
                <div class="p2">{{dataObj.userMerchantTypeDesc}}</div>
            </div>
            <div class="topBox-p org" v-if="dataObj.approvalStatus == 2">
                <div class="p1">未通过原因：</div>
                <div class="p2">{{dataObj.refuseReason}}</div>
            </div>
       </div>
       <div class="centerBox">
            <div class="p1">有效证件：</div>
                <div class="p2">
                    <div class="imgWs">
                        <div class="imgW" v-if="dataObj.portraitFaceImg">
                            <div class="imgs" @click="bigImg(dataObj.portraitFaceImg)">
                                <img :src="$store.state.imgUrl+dataObj.portraitFaceImg" alt="">
                            </div>
                            <div class="imgTxt">身份证-人像面</div>
                        </div>
                        <div class="imgW" v-if="dataObj.nationalEmblemImg">
                            <div class="imgs" @click="bigImg(dataObj.nationalEmblemImg)">
                                <img :src="$store.state.imgUrl+dataObj.nationalEmblemImg" alt="">
                            </div>
                            <div class="imgTxt">身份证-国徽面</div>
                        </div>
                        <div class="imgW" v-if="dataObj.businessLicenseImg">
                            <div class="imgs" @click="bigImg(dataObj.businessLicenseImg)">
                                <img :src="$store.state.imgUrl+dataObj.businessLicenseImg" alt="">
                            </div>
                            <div class="imgTxt">营业执照</div>
                        </div>
                        <div class="imgW" v-if="dataObj.medicineLicenseImg">
                            <div class="imgs" @click="bigImg(dataObj.medicineLicenseImg)">
                                <img :src="$store.state.imgUrl+dataObj.medicineLicenseImg" alt="">
                            </div>
                            <div class="imgTxt">药品经营许可证</div>
                        </div>
                        <div class="imgW" v-if="dataObj.medicalInstitutionImg">
                            <div class="imgs" @click="bigImg(dataObj.medicalInstitutionImg)">
                                <img :src="$store.state.imgUrl+dataObj.medicalInstitutionImg" alt="">
                            </div>
                            <div class="imgTxt">医疗机构执业许可证</div>
                        </div>
                        <div class="imgW" v-if="dataObj.zhongyiCertificateImg">
                            <div class="imgs" @click="bigImg(dataObj.zhongyiCertificateImg)">
                                <img :src="$store.state.imgUrl+dataObj.zhongyiCertificateImg" alt="">
                            </div>
                            <div class="imgTxt">中医备案证</div>
                        </div>
                        <div v-if="dataObj.medicalPractitionerCertificateImg">
                            <div class="imgW" v-for="(item,index) in medicalPractitionerCertificateImgList" :key="index">
                                <div class="imgs" @click="bigImg(item)">
                                    <img :src="$store.state.imgUrl+item" alt="">
                                </div>
                                <div class="imgTxt">医师执业证书{{index+1}}</div>
                            </div>   
                        </div>
                        <div v-if="dataObj.authorizationImg">
                            <div class="imgW" v-for="(item2,index2) in authorizationImgList" :key="index2">
                                <div class="imgs" @click="bigImg(item2)">
                                    <img :src="$store.state.imgUrl+item2" alt="">
                                </div>
                                <div class="imgTxt">授权书{{index2+1}}</div>
                            </div>
                    </div>    
                </div>
            </div>
        </div>
        <el-dialog
        title=""
        :visible.sync="centerDialogVisible"
        width="30%"
        center>
        <div class="bigImg">
            <img :src="$store.state.imgUrl+imgUrlStr" />
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="centerDialogVisible = false">关 闭</el-button>
        </span>
    </el-dialog>
        <el-dialog
            title="注意"
            :visible.sync="tipsFlag"
            width="30%"
            center>
            <span v-html="content"></span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="goEdit">继续编辑</el-button>
                <el-button type="primary" @click="tipsFlag = false">退出编辑</el-button>
            </span>
        </el-dialog>
    </div>
    <div class="noData" v-else>
            <img src="@/assets/img/quesheng2.png" alt="">
            <div @click="goWholesaler">注册批发商</div>
        </div>
    </div>
   
 
</template>

<script>
export default {
    name: "wholesalerInfo",
    data() {
        return {
           dataObj:{},
           medicalPractitionerCertificateImgList:[],
           authorizationImgList:[],
           imgUrlStr:'',
           centerDialogVisible:false,
           tipsFlag: false,
           content:''
        };
    },
    methods: {
        getData(){
            let that = this;
            let url = "/user/merchant/getUserMerchant";
            that.$http
                .post(url)
                .then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        that.dataObj = res.data;
                         //医师执业证书
                         that.medicalPractitionerCertificateImgList =  that.dataObj.medicalPractitionerCertificateImg.split(",");
                       //授权书
                        that.authorizationImgList =  that.dataObj.authorizationImg.split(",");
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(() => {
                });
        },
        bigImg(img){
            this.imgUrlStr = img;
            this.centerDialogVisible = true;
        },
        edit(){
            if(this.dataObj.approvalStatus == 1){
               this.content = `    您当前已具备批发商的身份资格。但请注意，若您决定修改相关资料，系统将自动引导您进入审核中心重新进行审核流程。此审核过程预计耗时1-3个工作日。在此期间，您的批发商资格将暂时失效，直至审核成功通过后方可恢复。提交完成后，需要您重新登录。请问，您是否确定要继续前往进行资料编辑?`
            }else if(this.dataObj.approvalStatus == 2){
                this.content = `    请注意，若您决定修改相关资料，系统将自动引导您进入审核中心重新进行审核流程。此审核过程预计耗时1-3个工作日。在此期间，您的批发商资格将暂时失效，直至审核成功通过后方可恢复。提交完成后，需要您重新登录。请问，您是否确定要继续前往进行资料编辑?`
            }
            this.tipsFlag = true;
           
        },
        goEdit(){
              this.$router.push({
                path: "wholesaler",
                query: { type: "edit" }
            });
        },
        goWholesaler(){
            this.$router.push({
                path: "wholesaler"
            });
        }
    },
    created() {
       this.getData();
       let that = this;
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        }
    }
};
</script>
<style scoped>
.wrap{
    position: relative;
    width: 100%;
    height: 100%;
    background: #fff;
    box-sizing: border-box;
    padding: 30px 20px;
}
.topBtn{
    position: absolute;
    right: 140px;
    top:30px;
}
.topBox{
    width: 100%;
}
.topBox::after,.topBox-p::after{
    content: "";
    display: block;
    overflow: hidden;
    visibility: hidden;
    clear: both;
}
.org{
    color: #f64420;
    font-weight: 600;
    font-size: 16px;
}
.topBox-p{
    min-height: 30px;
    line-height: 30px;
    box-sizing: border-box;
}
.topBox-p .p1{
    float: left;
    text-align: right;
    width: 100px;
}
.topBox-p .p2{
    float: left;
}
.topBox-p .p3{
    float: left;
    color: #f64420;
    position: absolute;
    right:130px;
    top:30px;
}
.topBox-p .p3 .img1{
    width: 100px;
}
.topBox-p .p4{
    float: left;
    color: #f64420;
    position: absolute;
    right: 143px;
    top: 57px;
}
.topBox-p .p4 .img1{
    width: 50px;
}
.topBox-p .p5{
    float: left;
    color: #f64420;
    position: absolute;
    right: 143px;
    top: 57px;
}
.topBox-p .p5 .img1{
    width: 100px;
}
.centerBox{
    width: 100%;
    margin-top:10px;
}
.centerBox::after{
    content:'';
    display: block;
    overflow: hidden;
    visibility: hidden;
    clear: both;
} 
.centerBox .p1{
    width: 100px;
    float: left;
    text-align: right;
}
.centerBox .p2{
    float: left;
    width: 700px;
}
.centerBox .p2 .imgWs{
    width: 100%;
    height: 100%;
}
.centerBox .p2 .imgWs .imgW{
    width: 40%;
    float: left;
    margin-right:20px ;
}
.centerBox .p2 img{
    width: 100%;
    height: 180px;
}
.centerBox .p2 .imgTxt{
    text-align: center;
    margin-top:8px;
    height: 30px;
}
.bigImg{
    width: 100%;
   
}
.bigImg img{
    width: 100%;
    height: auto;
}
.noData{
    width: 100%;
    min-height: 545px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    img{
        width:417.42px;
        height: 310.94px;
        margin-bottom: 20px;
    }
    div{
        width:417px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        color: #fff;
        background-color: #f64420;
    }
}
/* <div class="noData" v-else>
            <img src="@/assets/img/quesheng2.png" alt="">
            <div>注册批发商</div>
        </div> */
</style>


// WEBPACK FOOTER //
// src/components/JW/wholesalerInfo.vue